import leaflet from 'leaflet' // eslint-disable-line no-unused-vars

export default {
  marker: L.icon({
    iconUrl: '/leaflet/marker-icon.png',
    shadowUrl: '/leaflet/marker-shadow.png',
    iconAnchor: [12, 40],
    popupAnchor: [0, -35]
  }),
  markerDeactivated: L.icon({
    iconUrl: '/leaflet/marker-icon-deactivated.png',
    shadowUrl: '/leaflet/marker-shadow.png',
    iconAnchor: [12, 40],
    popupAnchor: [0, -35]
  }),
  sennderMarker: L.icon({
    iconUrl: '/leaflet/sennder-marker.png',
    shadowUrl: '/leaflet/marker-shadow.png',
    iconAnchor: [12, 40],
    popupAnchor: [0, -35]
  }),
  sennder_online: L.icon({
    iconUrl: '/leaflet/sennder-marker.png',
    shadowUrl: '/leaflet/marker-shadow.png',
    iconAnchor: [9, 30],
    popupAnchor: [0, -30],
    iconSize: [18, 30],
    shadowSize: [30, 30]
  }),
  sennder_offline: L.icon({
    iconUrl: '/leaflet/sennder-marker-deactivated.png',
    shadowUrl: '/leaflet/marker-shadow.png',
    iconAnchor: [9, 30],
    popupAnchor: [0, -30],
    iconSize: [18, 30],
    shadowSize: [30, 30]
  }),
  navigation_online: L.icon({
    iconUrl: '/leaflet/navigation_online.png',
    iconAnchor: [12, 12],
    iconSize: [24, 24],
    popupAnchor: [0, -10]
  }),
  navigation_offline: L.icon({
    iconUrl: '/leaflet/navigation_offline.png',
    iconAnchor: [12, 12],
    iconSize: [24, 24],
    popupAnchor: [0, -10]
  }),
  blue_circle: L.icon({
    iconUrl: '/leaflet/blue-circle.png',
    iconAnchor: [5, 5],
    iconSize: [10, 10]
  }),
  gray_circle: L.icon({
    iconUrl: '/leaflet/gray-circle.png',
    iconAnchor: [6, 6],
    iconSize: [12, 12],
    popupAnchor: [0, -10]
  }),
  sennder_circle: L.icon({
    iconUrl: '/leaflet/sennder-circle.png',
    iconAnchor: [6, 6],
    iconSize: [12, 12],
    popupAnchor: [0, -10]
  }),
  highlight: icon =>
    L.icon({
      iconUrl: icon.options.iconUrl,
      iconSize: icon.options.iconSize.map(s => s * 1.5),
      iconAnchor: icon.options.iconAnchor.map(s => s * 1.5)
    })
}
